/**
 * Dostepne statusy zwrotu transakcji p24
 */
export const P24TransactionRefundStatus = {

    /**
     * Brak zwrotu
     */
    NONE: { id: 0, name: 'NONE', displayText: '', iconCss: '' },
    /**
     * Zwrot Transakcji został zarejestrowany w PRZELEWY24.
	 * 
	 * Kwota zwrotu jest mniejsza od kwoty transakcji
     */
    REGISTERED_PARTIALLY: { id: 1, name: 'REGISTERED_PARTIALLY', displayText: 'W trakcie zwrotu częściowego', iconCss: 'fas fa-adjust', colorCss: 'pink' },
    /**
      * Zwrot transakcji został potwierdzona przez PRZELEWY24 poprzez połaczenie się na nasz endpoint /v1/api/p24/transactions/notifications/redund/rest.
      * 
      * Zwrot został otrzymany przez odbiorcę.
      * 
      * Zwrot częściowy - nie na pełną kwotę transakcji.
      */
    NOTIFIED_PARTIALLY: { id: 2, name: 'NOTIFIED_PARTIALLY', displayText: 'Zwrócony częściowo', iconCss: 'fas fa-adjust', colorCss: 'green' },
    /**
      * Zwrot Transakcji został zarejestrowany w PRZELEWY24.
      * 
      * Kwota zwrotu jest równa kwocie transakcji
      */
    REGISTERED: { id: 3, name: 'REGISTERED', displayText: 'W trakcie zwrotu', iconCss: 'fas fa-circle', colorCss: 'pink' },
    /**
	 * Zwrot transakcji został potwierdzona przez PRZELEWY24 poprzez połaczenie się na nasz endpoint /v1/api/p24/transactions/notifications/redund/rest.
	 * 
	 * Zwrot został otrzymany przez odbiorcę.
	 * 
	 * Zwrot całkowity - na pełną kwotę transakcji
	 */
    NOTIFIED: { id: 4, name: 'NOTIFIED', displayText: 'Zwrócony', iconCss: 'fas fa-circle', colorCss: 'green' }

}

/**
 * Kolekcja statusow
 */
export const P24TransactionRefundStatusList = Object.keys(P24TransactionRefundStatus).map(type => P24TransactionRefundStatus[type])

/**
 * Metoda zwracająca status transakcji bazując na identyfikatorze
 * 
 * @param {int} id identyfikator statusu transakcji
 * 
 * @returns {P24TransactionRefundStatus} status transakcji
 */
export const getP24TransactionRefundStatusById = (id) => {
    if (!id) {
        return P24TransactionRefundStatus.NONE;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let transactionRefundStatus = P24TransactionRefundStatusList.find(item => item.id === id)
    return transactionRefundStatus;
}